import styled from 'styled-components';
import { media } from '../../hooks/use-responsive-v2.hook';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var LogoContentWrapper = styled.div.withConfig({
  displayName: "logo-wrapper__LogoContentWrapper",
  componentId: "sc-1wcs47r-0"
})(["display:flex;align-items:center;gap:12px;"]);
var LogoImage = styled.img.withConfig({
  displayName: "logo-wrapper__LogoImage",
  componentId: "sc-1wcs47r-1"
})(["flex-shrink:0;display:block;", "{", "}"], media.mobile, function (props) {
  return props.$compactMobile && 'width: 32px; height: 32px; object-fit: contain;';
});
var LogoText = styled.div.withConfig({
  displayName: "logo-wrapper__LogoText",
  componentId: "sc-1wcs47r-2"
})(["display:flex;flex-direction:column;align-items:center;line-height:1.2;", "{", "}"], media.mobile, function (props) {
  return props.$compactMobile && 'display: none;';
});
var LogoTitle = styled.span.withConfig({
  displayName: "logo-wrapper__LogoTitle",
  componentId: "sc-1wcs47r-3"
})(["font-weight:700;font-size:16px;color:#0f172a;"]);
var LogoSubtitle = styled.span.withConfig({
  displayName: "logo-wrapper__LogoSubtitle",
  componentId: "sc-1wcs47r-4"
})(["font-size:12px;color:#64748b;"]);
export var LogoWrapper = function LogoWrapper(_ref) {
  var subTitle = _ref.subTitle,
      logoSrc = _ref.logoSrc,
      logoTitleSrc = _ref.logoTitleSrc,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'Digibricks' : _ref$title,
      _ref$logoWidth = _ref.logoWidth,
      logoWidth = _ref$logoWidth === void 0 ? 36 : _ref$logoWidth,
      _ref$logoHeight = _ref.logoHeight,
      logoHeight = _ref$logoHeight === void 0 ? 36 : _ref$logoHeight,
      _ref$collapsed = _ref.collapsed,
      collapsed = _ref$collapsed === void 0 ? false : _ref$collapsed,
      _ref$compactOnMobile = _ref.compactOnMobile,
      compactOnMobile = _ref$compactOnMobile === void 0 ? false : _ref$compactOnMobile;
  return /*#__PURE__*/_jsxs(LogoContentWrapper, {
    children: [/*#__PURE__*/_jsx(LogoImage, {
      $compactMobile: compactOnMobile,
      src: logoSrc,
      alt: title,
      width: logoWidth,
      height: logoHeight
    }), !collapsed && /*#__PURE__*/_jsxs(LogoText, {
      $compactMobile: compactOnMobile,
      children: [/*#__PURE__*/_jsx(LogoImage, {
        src: logoTitleSrc,
        alt: title
      }), /*#__PURE__*/_jsx(LogoSubtitle, {
        children: subTitle
      })]
    })]
  });
};